// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"ql","checked":"qm","unchecked":"qn"};